import { Trace } from '@abiglobalhealth/go-types'
import { Dispatch, SetStateAction, useContext } from 'react'

import { JourneyContext } from '@/contexts/journey'
import { formatTrace } from '@/utils/traces'

interface UseTracesProps {
  traces: Trace[]
  updateTraces: (traces: Trace[]) => void
  setTraces: Dispatch<SetStateAction<Trace[]>>
  addTrace: (moduleId: string, stepId?: string) => void
}

export const useTraces = (): UseTracesProps => {
  const { traces, setTraces } = useContext(JourneyContext)

  const updateTraces = (traces: Trace[]) => {
    setTraces(traces)
  }

  const addTrace = (moduleId: string, stepId?: string) => {
    if (stepId) {
      return setTraces((prev) => {
        const prevTrace = prev[prev.length - 1]
        // If previous trace is the same as the current one, don't add it
        if (prev.length > 0 && 'stepId' in prevTrace && prevTrace?.stepId === stepId && prevTrace?.moduleId === moduleId) {
          return prev
        }

        return [...prev, formatTrace(moduleId, stepId, prev)]
      })
    }

    setTraces((prev) => {
      const prevTrace = prev[prev.length - 1]
      // If previous trace is the same as the current one, don't add it
      if (prev.length > 0 && prevTrace?.moduleId === moduleId) return prev

      return [...prev, formatTrace(moduleId, undefined, prev)]
    })
  }

  return {
    traces,
    updateTraces,
    setTraces,
    addTrace
  }
}
